module.exports = __webpack_public_path__ + "img/L1_open.d27f3e95.svg";